import { useState, useEffect } from "react";
import { Col, Card, Button } from "react-bootstrap";
import { AiFillGithub, AiFillInstagram } from "react-icons/ai";
import { FaLinkedinIn, FaWhatsapp } from "react-icons/fa";

function AboutCard() {
  const [animate, setAnimate] = useState(false);
  const [showMore, setShowMore] = useState(false);

  useEffect(() => {
    setAnimate(true);
  }, []);

  const handleToggle = () => {
    setShowMore(!showMore);
  };

  const shortText = (
    <>
      Hi, I’m <span className="purple">Muhammad Ali</span>, a <strong>Full Stack Developer</strong> with expertise across three core areas —{" "}
      <strong>MERN Stack</strong>, <strong>Angular</strong>, and <strong>WordPress</strong> development.
      I build everything from dynamic full-stack applications to enterprise dashboards and professional business websites.
    </>
  );

  const fullText = (
    <>
      {shortText}
      <br /><br />
      On the <strong>MERN Stack</strong> side, I build scalable React frontends paired with Node.js + Express backends and MongoDB, with JWT authentication and REST APIs.
      <br /><br />
      With <strong>Angular</strong>, I develop enterprise-grade dashboards and SaaS platforms using TypeScript, RxJS, PrimeNG, and NgRx for complex state management.
      <br /><br />
      For <strong>WordPress</strong>, I design and deliver pixel-perfect business websites and landing pages using Elementor — including e-commerce stores, agency sites, and community platforms.
      <br /><br />
      My focus is always on performance, clean code, and delivering real business value.
    </>
  );



  return (
    <Card className="quote-card-view" style={{ borderRadius: "15px" }}>
      <Card.Body style={{ padding: "0", paddingBottom: "10px" }}>
        <p className="home-about-body" style={{ fontSize: "1rem", lineHeight: "1.7", marginBottom: "10px" }}>
          {showMore ? fullText : shortText}
        </p>
        <Button
          size="sm"
          onClick={handleToggle}
          style={{ marginBottom: "15px" }}
        >
          {showMore ? "Show Less" : "Show More"}
        </Button>
      </Card.Body>

      <Col md={12} className={`home-about-social ${animate ? "animate-right" : ""}`}>
        <ul className="home-about-social-links">
          <li className="social-icons">
            <a
              href="https://github.com/Mali5341"
              target="_blank"
              rel="noreferrer"
              className="icon-colour home-social-icons"
            >
              <AiFillGithub />
            </a>
          </li>
          <li className="social-icons">
            <a
              href="https://wa.me/+923083653441"
              target="_blank"
              rel="noreferrer"
              className="icon-colour home-social-icons"
            >
              <FaWhatsapp />
            </a>
          </li>
          <li className="social-icons">
            <a
              href="https://www.linkedin.com/in/m-ali-4816412bb/"
              target="_blank"
              rel="noreferrer"
              className="icon-colour home-social-icons"
            >
              <FaLinkedinIn />
            </a>
          </li>
          <li className="social-icons">
            <a
              href="https://www.instagram.com/mali4_41/"
              target="_blank"
              rel="noreferrer"
              className="icon-colour home-social-icons"
            >
              <AiFillInstagram />
            </a>
          </li>
        </ul>
      </Col>
    </Card>
  );
}

export default AboutCard;
